import React from 'react';
import { renderContent } from 'utilities/content/content-utilities';
import { PriceTerm } from 'types/Product';
import { DialogSection, DialogText } from '../../styles/DialogStyles';

interface Props {
  priceTerms: PriceTerm[];
}

function ViewAllStcOptions(props: Props) {
  const { priceTerms } = props;

  return (
    <DialogSection data-testid="view-all-stc-options">
      <DialogText size="1" tag="p" type="paragraph">
        {renderContent('littlewoods.viewAllStcOptions.header')}
      </DialogText>

      {priceTerms.map(({ apr, termPeriod, totalSellingPrice, weeklyPaymentAmount }, index) => (
        <DialogText data-testid={`price-term-${index}`} key={index} size="1" tag="p" type="paragraph">
          <strong>{weeklyPaymentAmount}</strong> per week - over {termPeriod} weeks
          {apr > 0 ? ` (${apr}% annual interest rate) Total ${totalSellingPrice}` : ' interest free (0% APR)'}
        </DialogText>
      ))}

      <DialogText size="1" tag="p" type="paragraph">
        <strong>{renderContent('littlewoods.spreadTheCostFurther.info2')}</strong>
      </DialogText>

      <DialogText size="1" tag="p" type="paragraph">
        {renderContent('littlewoods.spreadTheCostFurther.info3')}
      </DialogText>
    </DialogSection>
  );
}

export default ViewAllStcOptions;
